<template>
  <div class="app-page page box-card">
    <div class="box-card-content">
      <div class="account-info">

        <el-form :model="formData" ref="formData" class="reset-from">
          <div class="statistic-item">
            <div class="icon"> <i class="icon-wallet"></i></div>
            <div class="statistic-item-info">
              <span class="text">
                <I18Lang id="my16" defaultText="钱包" />
              </span>
              <span class="num">{{ walletInfo.balance }}</span>
            </div>
          </div>

          <el-form-item label="转出金额($)">
            <template slot="label">
              <I18Lang id="my62" defaultText="转出金额($)" />
            </template>
            <el-input type="number" v-model="formData.amount" class="reset-input" :placeholder="$t('my63')"></el-input>
          </el-form-item>

          <div :loading="isSubmitLoading" class="btn-submit kg-btn2" @click="submitData">
            <I18Lang id="my22" defaultText="立即提交" />
          </div>

          <div class="btn-submit kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>

        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>
          <el-table-column label="钱包余额($)" prop="balance">
            <template slot="header">
              <I18Lang id="my67" defaultText="钱包余额($)" />
            </template>
          </el-table-column>
          <el-table-column label="转账金额($)" prop="amount">
            <template slot="header">
              <I18Lang id="my68" defaultText="转账金额($)" />
            </template>
          </el-table-column>

          <el-table-column label="当前现金账户余额($)" prop="cash">
            <template slot="header">
              <I18Lang id="my69" defaultText="当前现金账户余额($)" />
            </template>
          </el-table-column>

          <el-table-column label="转账时间" prop="create_time">
            <template slot="header">
              <I18Lang id="my70" defaultText="转账时间" />
            </template>
          </el-table-column>

          <el-table-column label="转账说明">
            <template slot="header">
              <I18Lang id="my71" defaultText="转账说明" />
            </template>
            <template slot-scope="scope">
              {{ formatWalletRemark(scope.row.remark) }}
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
export default {
  name: 'home',
  data () {
    return {
      isSubmitLoading: false,
      walletInfo: {},
      queryForm: {
        page: 1,
        size: 10
      },
      tableData: {
        list: [],
        total: 0
      },
      formData: {
        amount: ''
      }
    }
  },
  created () {
    this.getWalletInfo()
    this.getRecord()
  },
  methods: {
    formatWalletRemark (remark) {
      const text = String(remark || '').trim()
      if (text === '利息返佣') {
        const locale = String(this.$i18n.locale || '').toLowerCase()
        if (locale.indexOf('ja') === 0) return '利息リベート'
        if (locale.indexOf('en') === 0) return 'Interest Commission'
        return '利息返佣'
      }
      const remarkMap = {
        赠金佣金: 'walletremark1',
        'Bonus Commission': 'walletremark1',
        ボーナスコミッション: 'walletremark1',
        佣金: 'walletremark2',
        交易佣金: 'walletremark2',
        Commission: 'walletremark2',
        'Trading Commission': 'walletremark2',
        コミッション: 'walletremark2',
        取引コミッション: 'walletremark2',
        钱包至现金: 'walletremark3',
        钱包转至现金: 'walletremark3',
        钱包至现金账户: 'walletremark3',
        钱包转至现金账户: 'walletremark3',
        转账到现金账户: 'walletremark3',
        'Wallet to Cash': 'walletremark3',
        'Transfer to Cash Account': 'walletremark3',
        ウォレットから現金: 'walletremark3',
        現金口座へ振替: 'walletremark3'
      }
      return remarkMap[text] ? this.$t(remarkMap[text]) : (text || '-')
    },
    getWalletInfo () {
      this.$http.post('/api/wallet/balance').then(result => {
        this.walletInfo = result
      })
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/wallet/streams?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http.post('/api/wallet/streams', this.queryForm).then(result => {
        this.tableData = result
      })
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    },
    isNumber (value) { // 验证是否为数字
      var patrn = /^(-)?\d+(\.\d+)?$/
      if (patrn.exec(value) == null || value === '') {
        return false
      } else {
        return true
      }
    },
    submitData () {
      if (!this.isNumber(this.formData.amount)) {
        this.$alert(this.$t('public29'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
        return false
      }
      if (this.formData.amount < 0 || this.formData.amount === 0) {
        this.$alert(this.$t('public30'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
        return false
      }
      this.isSubmitLoading = true
      this.$http.post('/api/wallet/transferToCash', this.formData).then(result => {
        this.$alert(`<h3>${this.$t('my26')}</h3>`, '', {
          confirmButtonText: this.$t('my25'),
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'success-alert',
          callback: action => {
            this.getRecord()
          }
        })
      }).finally(() => {
        this.isSubmitLoading = false
      })
    }
  },
  computed: {
    usdMoney () {
      return this.rate * this.formData.amount
    },
    isBalance () {
      return Number(this.formData.amount) > Number(this.userInfo.withdraw_cash)
    },
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
.page {
  .box-card-content {
    .account-info {
      padding-right: 30px;

      .reset-from {
        display: flex;

        .statistic-item {
          width: 260px;
          height: 90px;
          margin-left: 30px;
          background: url('../../../../assets/img/icon_dl.png') no-repeat center / 100% auto;
          display: flex;
          margin-right: 79px;

          .icon {
            width: 88px;
            height: 88px;
            flex: 0 0 88px;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon-wallet {
              width: 45px;
              height: 45px;
              display: block;
              background: url('../../../../assets/img/wallet.png') no-repeat center / 100%;
            }

          }

          .statistic-item-info {
            flex: 1;

            .text {
              font-size: 14px;
              font-weight: bold;
              color: #FFFFFF;
              display: block;
              text-align: center;
              padding-top: 15px;
            }

            .num {
              font-size: 28px;
              font-weight: 400;
              display: block;
              text-align: center;
              color: #00CBFA;
            }
          }
        }

        ::v-deep .el-form-item {
          margin-bottom: 40px;

          .el-form-item__label {
            font-size: 16px;
            font-family: Arial;
            font-weight: 400;
            color: #01B2F5;

          }

          .el-input__inner {
            width: 319px;
            height: 34px;
            border: 1px solid rgba(1, 178, 245, 0.5);
            line-height: 34px;
            background: transparent;
            color: #fff;
            border-radius: 0;
          }
        }

        .btn-submit {
          margin-top: 34px;
          margin-left: 10px;
          width: 110px;
          height: 55px;
          line-height: 55px;
        }
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .page {
    .box-card-content {
      .account-info {
        padding-right: 30px;

        .reset-from {
          display: flex;

          .statistic-item {
            width: 460px;
            height: 90px;
            margin-left: 0;
            background: url('../../../../assets/img/icon_dl.png') no-repeat center / 100% 100%;
            display: flex;
            margin-right: 20px;

            .icon {
              width: 88px;
              height: 88px;
              flex: 0 0 88px;
              display: flex;
              align-items: center;
              justify-content: center;

              .icon-wallet {
                width: 45px;
                height: 45px;
                display: block;
                background: url('../../../../assets/img/wallet.png') no-repeat center / 100%;
              }

            }

            .statistic-item-info {
              flex: 1;

              .text {
                font-size: 14px;
                font-weight: bold;
                color: #FFFFFF;
                display: block;
                text-align: center;
                padding-top: 15px;
              }

              .num {
                font-size: 28px;
                font-weight: 400;
                display: block;
                text-align: center;
                color: #00CBFA;
              }
            }
          }

          ::v-deep .el-form-item {
            margin-bottom: 40px;

            .el-form-item__label {
              font-size: 20px;
              font-family: Arial;
              font-weight: 400;
              color: #01B2F5;

            }

            .el-input__inner {
              width: 319px;
              height: 60px;
              border: 1px solid rgba(1, 178, 245, 0.5);
              line-height: 60px;
              font-size: 18px;
              background: transparent;
              color: #fff;
              border-radius: 0;
            }
          }

          .btn-submit {
            margin-top: 27px;
            margin-left: 10px;
            width: 250px;
            height: 85px;
            line-height: 85px;
          }
        }
      }
    }
  }
}
</style>
